// extracted by mini-css-extract-plugin
export default {"tick_div":"Navar_tick_div__45GQC","all_safe":"Navar_all_safe__yMys8"};